import axios from 'axios';
import { Cart } from '../models/cart';

export function getCart() {
  return axios.get<Cart>('/api/cart').then(response => response.data);
}
